export default "__VITE_ASSET__XbuEZxX9__"